import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from 'lodash'
import { useAppDispatch } from "../../../hooks/hooks";
import { helpTopics } from "../../../redux/help-topics/action";
import { selectHelpTopicsListItems } from "../../../redux/help-topics/selector";
import Accodion from "../../../common/components/Accodion";
import { ServiceRequest } from "../service-request";
import useWindowDimensions from "../../../hooks/useWindowsDimensions";

export default function Faq() {
  const dispatch = useAppDispatch();
  const { height, width } = useWindowDimensions();
  const listHelpTopics = useSelector(selectHelpTopicsListItems)
  const [topics, setTopics] = useState<any>([]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(helpTopics.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/cms/help-topics/list`, entity: 'helpTopics', jsonData:
      {
      }
    }))
  }, [])

  useEffect(() => {
    if (listHelpTopics) {
      setTopics(listHelpTopics?.result?.items);
    }
  }, [listHelpTopics])

  return (
    <>
      {width && width < 720 ?
        <div className="py-20">
          <div className="flex justify-center">
            <h1 className="text-3xl font-semibold text-qblack p-5"> Frequently asked questions</h1>
          </div>
          <div className="contact-wrapper w-full p-5 mb-10">
            <div className="container-x mx-auto">
              <div className="main-wrapper w-full lg:flex lg:space-x-[30px]">
                <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
                  <h1 className="text-qblack font-bold text-[22px] mb-4">
                    Frequently asked questions
                  </h1>
                  <div className="flex flex-col space-y-7 justify-between">
                    {topics && _.map(topics, (item: any) => (
                      <Accodion
                        title={item.Title}
                        des={item.Body}
                        type='html'
                      />
                    ))

                    }
                  </div>
                </div>
                <ServiceRequest />
              </div>
            </div>
          </div>
        </div>
        :
        <div className="py-16">
          <div className="flex justify-center">
            <h1 className="text-3xl font-semibold text-qblack p-5"> Frequently asked questions</h1>
          </div>
          <div className="contact-wrapper w-full p-5 mb-10">
            <div className="container-x mx-auto">
              <div className="main-wrapper w-full lg:flex lg:space-x-[30px]">
                <div className="lg:w-1/2 w-full mb-10 lg:mb-0">
                  <h1 className="text-qblack font-bold text-[22px] mb-4">
                    Frequently asked questions
                  </h1>
                  <div className="flex flex-col space-y-7 justify-between">
                    {topics && _.map(topics, (item: any) => (
                      <Accodion
                        title={item.Title}
                        des={item.Body}
                        type='html'
                      />
                    ))

                    }
                  </div>
                </div>
                <ServiceRequest />
              </div>
            </div>
          </div>
        </div>}
    </>



  );
}
